<template>
  <div id="app">
      <b-container>
      <header>
      <b-alert :show="dismissCountDown"
               dismissible
               variant="danger"
               @dismissed="dismissCountDown=0"
               @dismiss-count-down="countDownChanged">
          <p>Connection to backend fails. Retry in {{dismissCountDown}} seconds...</p>
          <b-progress variant="info"
                      :max="dismissSecs"
                      :value="dismissCountDown"
                      height="4px">
          </b-progress>
      </b-alert>
          <h1>Cloud server price calculator</h1>
      </header>
      <main>
          <b-row class="mt-md-3">
              <b-col cols="12" md="2" class="text-md-right"><img class="icon" src="icons/cpu.svg" alt="CPU sign">CPU:</b-col>
              <b-col cols="7" md="5"><b-form-input v-model="vm_props.cpu_count"
                                                   type="range" class="custom-range"
                                                   min="1" max="16"></b-form-input></b-col>
              <b-col cols="5" md="3" lg="2">
                  <div class="input-group">
                      <b-form-input v-model="vm_props.cpu_count"
                                    type="number" :formatter="checkNumberRange" @blur.native="correctNumberRange" min="1" max="16"></b-form-input>

                      <div class="input-group-append">
                          <div class="input-group-text">vCPU</div>
                      </div>
                  </div>
              </b-col>
          </b-row>
          <b-row class="mt-md-3">
              <b-col cols="12" md="2" class="text-md-right"><img class="icon" src="icons/ram.svg" alt="RAM sign">RAM:</b-col>
              <b-col cols="7" md="5"><b-form-input v-model="vm_props.memory_size"
                                                   type="range" class="custom-range"
                                                   min="1" max="64"></b-form-input></b-col>
              <b-col cols="5" md="3" lg="2">
                  <div class="input-group">
                      <b-form-input v-model="vm_props.memory_size"
                                    type="number" :formatter="checkNumberRange" @blur.native="correctNumberRange" min="1" max="64"></b-form-input>
                      <div class="input-group-append">
                          <div class="input-group-text">GB</div>
                      </div>
                  </div>
              </b-col>
          </b-row>
          <b-row class="mt-md-3">
              <b-col cols="12" md="2" class="text-md-right"><img class="icon" src="icons/hdd.svg" alt="HDD sign">HDD:</b-col>
              <b-col cols="7" md="5"><b-form-input v-model="vm_props.disk_size"
                                                   type="range" class="custom-range"
                                                   min="10" max="750"></b-form-input></b-col>
              <b-col cols="5" md="3" lg="2">
                  <div class="input-group">
                      <b-form-input v-model="vm_props.disk_size"
                                    type="number" :formatter="checkNumberRange"  @blur.native="correctNumberRange" min="10" max="750"></b-form-input>
                      <div class="input-group-append">
                          <div class="input-group-text">GB</div>
                      </div>
                  </div>
              </b-col>
          </b-row>
          <b-row class="mt-md-3">
              <b-col cols="5" lg="2" class="text-lg-right">Secure cloud:</b-col>
              <b-col cols="5" lg="2">
                  <switches v-model="vm_props.secure_cloud" theme="bootstrap" color="success"></switches>
              </b-col>
              <b-col cols="5" lg="2" class="text-lg-right">Disaster recovery:</b-col>
              <b-col cols="6" lg="4">
                  <switches v-model="vm_props.disaster_recovery" theme="bootstrap" color="success"></switches>
              </b-col>
          </b-row>
          <b-row class="mt-md-3">
              <b-col cols="12" lg="2" class="text-lg-right">Operační systém:</b-col>
              <b-col cols="12" lg="5">
                  <v-select v-model="vm_props.os" label="name" :options="os_options">
                      <template slot="no-options">
                          Takový operační systém není k dispozici
                      </template>
                      <template slot="option" slot-scope="option">
                          <div class="d-center">
                              <img  class="icon" :src="option.icon"/>
                              {{ option.name }}
                          </div>
                      </template>
                      <template slot="selected-option" scope="option">
                          <div class="selected d-center">
                              <img  class="icon" :src="option.icon"/>
                              {{ option.name }}
                          </div>
                      </template>
                  </v-select>
              </b-col>
          </b-row>
          <b-row class="mt-md-3">
              <b-col  cols="12" md="2" class="text-md-right"><img class="icon" src="icons/dollar-sign.svg" alt="Price sign">Cena:</b-col>
              <b-col cols="0" md="5"></b-col>
              <b-col cols="12" md="auto" class="text-center">
                  <b-alert variant="warning" v-if="price_loading" show>Načítám cenu <ball-pulse-loader color="#856404" size="6px"></ball-pulse-loader></b-alert>
                  <b-alert variant="success" v-else show>{{ price }} CZK/měsíc</b-alert>
              </b-col>
          </b-row>
      </main>
      </b-container>
  </div>
</template>

<script>
import Switches from 'vue-switches';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';
import vSelect from 'vue-select'

var BE_URL = `https://be.bbocal.mejty.cz/`

export default {
  name: 'app',
    data () {
    return {
        vm_props: {cpu_count: 1, memory_size: 1, disk_size: 10, secure_cloud: true, disaster_recovery: false, os: undefined},
        os_options: [],
        os_default: {},
        price: 0,
        price_loading: true,
        dismissSecs: 5,
        dismissCountDown: 0,
    }
  },
    components: {
        Switches,
        'v-select': vSelect,
        BallPulseLoader,
    },
    beforeMount(){
        let local_vm_props = JSON.parse(localStorage.getItem('vm_props'))
        this.getSupportedOs()
        if (local_vm_props) {
            if (Object.keys(this.vm_props).every(key => local_vm_props.hasOwnProperty(key))) {
                this.vm_props = local_vm_props
                this.vm_props.os = local_vm_props.os
            }
            else{
                localStorage.removeItem('vm_props')
            }
        }
    },
    watch: {
        vm_props: {
            handler: function (newProps, oldProps) {
                if (this.vm_props.os === null){
                    this.vm_props.os = Object.assign ({}, this.os_default)
                    return
                }
                localStorage.setItem('vm_props', JSON.stringify(this.vm_props))
                this.price_loading = true
                this.getPrice()
            },
            deep: true
        },
    },
    methods: {
        getPrice: function () {
            var vm = this
            let jsonHeaders = new Headers({
                'Content-Type': 'application/json',
            })
            fetch(`${BE_URL}price`, {
                body: JSON.stringify(this.vm_props),
                method: 'POST',
                headers: jsonHeaders,
                redirect: 'follow',
            }).then(response => {
                if (response.status != 200){
                    response.text().then(text => {
                        console.log(text)
                        throw Error(text)
                    })
                }
                else {
                    vm.price_loading = false
                    response.json().then(data => vm.price = data['price'])
                }
            }).catch(e => {
                console.log(e)
                vm.fetchError();
                setTimeout(vm.getPrice.bind(vm), (vm.dismissSecs+1) * 1000)
            })
        },
        getSupportedOs: function(){
            var vm = this
            let jsonHeaders = new Headers({
                'Content-Type': 'application/json',
            })
            fetch(`${BE_URL}os`, {
                method: 'GET',
                headers: jsonHeaders,
                redirect: 'follow',
            }).then(response => {
                if (response.status != 200){
                    response.text().then(text => {
                            console.log(text)
                            throw Error(text)
                        }
                    )
                }
                else {
                    response.json().then(data => {
                        vm.os_options = data
                        vm.os_default = Object.assign ({}, data[0])
                        if (vm.vm_props.os === undefined) {
                            vm.vm_props.os = Object.assign({}, data[0])
                        }
                    })
                }
            }).catch(e => {
                console.log(e)
                vm.fetchError();
                setTimeout(vm.getSupportedOs.bind(vm), (vm.dismissSecs+1) * 1000)
            })

        },
        fetchError: function () {
            if (this.dismissCountDown === 0) {
                this.dismissCountDown = this.dismissSecs
            }
        },
        countDownChanged: function (dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        checkNumberRange: function (value, event) {
            if(value > parseInt(event.target.max)){
                return event.target.max
            }
            else if (value < parseInt(event.target.min)){
                return event.target.min
            }
            return value
        },
        correctNumberRange: function (event) {
            let value = event.target.value
            if(value > parseInt(event.target.max)){
                event.target.value = event.target.max
            }
            else if (value < parseInt(event.target.min)){
                event.target.value = event.target.min
            }
        },
    }
}
</script>

<style>
    body{
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .icon{
        width: 2em;
        height: 2em;
        margin-right: 10px;
    }

    #app .dropdown li a {
        padding: 10px 20px;
        display: flex;
        width: 100%;
        align-items: center;
        font-size: 1.25em;
    }

    .selected .icon{
        max-height: 23px;
        max-width: 23px;
    }

    button.clear {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue